module.exports = __webpack_public_path__ + "img/fosunEasy.0d055d28.png";